var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMoveNodeActive)?_c('AppFooterWrapper',{staticClass:"move-step-footer",on:{"cancel":_vm.setMoveStepLocationInTreeInactive}},[_c('span',{staticClass:"flex-centerize footer-text pointer-events-none"},[_vm._v(" Click any "),_c('div',{staticClass:"mx-2 plus-btn flex-centerize"},[_vm._v("+")]),_vm._v(" To move step location ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }